var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitchLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 127.77,
    viewBox: "0 0 112 127.77",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -180.53 935.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.1 637.51h17.549v-11.698l11.698 11.698h21.445l13.652 13.651v42.892h-64.345z",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 71.475,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.45 651.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.652-13.651h-21.445l-11.699-11.697v11.697h-17.548v56.544h64.344zm-72.146 50.692-3.899-15.599v-70.19h17.55v-9.751h9.746l9.752 9.751h15.596l31.196 31.192v54.597z",
    fill: "#6441a5",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m168.55 655.05h7.799v23.401h-7.799zm21.446 0h7.799v23.401h-7.799z",
    fill: "#6441a5",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchLogo);
export default __webpack_public_path__ + "static/media/Twitch_logo.353efd2b2decd52830750e211b388b64.svg";
export { ForwardRef as ReactComponent };